export default {
  messageName: 'workbox-broadcast-update',
}
